export function createStringVariables(variableNames) {
  return {
    variableTypes: variableNames.reduce((prev, name) => `${prev} $${name}: String,`, ''),
    variables: variableNames.reduce((prev, name) => `${prev} ${name}: $${name}`, '')
  };
}
const dateVariableSuffixes = ['', '__date', '__date__gt', '__date__gte', '__date__lt', '__date__lte'];
export function createDateStringVariables(variableName) {
  return dateVariableSuffixes.map(suffix => `${variableName}${suffix}`);
}
export function createDateRangeVariables(variableName) {
  return [`${variableName}__range_after`, `${variableName}__range_before`];
}
export function createComparableVariables(variableName) {
  const suffixes = ['', '__lt', '__lte', '__gt', '__gte'];
  return suffixes.map(suffix => `${variableName}${suffix}`);
}